import styled from 'styled-components'

export const StyledFlag = styled.div`
  display: inline-block;
`
